<div class="lvi-content">
    <div class="avatar">
        <span>{{ getAvatar(data.fonction) }}</span>
    </div>
    <div class="lvi-body">
        <div class="title">
            <a (click)="onSelect()">{{ getFonctionLibelle(data.fonction) }}</a>
        </div>
        <ul class="lvi-attrs">

            <li>
                <strong [translate]="'admin.entreprise.populations.usage.nombreUtilisateurs'"></strong>
                <span>{{ data.nbUtilisateurs }}</span>
            </li>
        </ul>
    </div>
</div>
